import { ReactComponent as BigX } from 'assets/empty-block.svg';

export interface IDisplayImageInfoProps {
  imageUrl?: string | null;
  imageName?: string;
}

/**
 * Displays image and its name
 */
export function DisplayImageInfo({ imageUrl, imageName }: IDisplayImageInfoProps) {
  return (
    <div className="dpc-image-info-editor">
      {!imageUrl && (
        <div className="dpc-image-info-editor__icon">
          <BigX />
        </div>
      )}
      {imageUrl && <img className="dpc-image-info-editor__icon--active" alt={imageName} src={imageUrl} />}
      <label className="dpc-image-info-editor__label">{imageName || 'n/a'}</label>
    </div>
  );
}
